const statuses = {
	product: 'product',
	documents: 'documents',
	banners: 'banners',
	creatives: 'creatives'
};

const locale = {
	ru: {
		product: 'Продукт',
		documents: 'Документы',
		banners: 'Баннеры',
		creatives: 'Креативы'
	},
	en: {
		product: 'Product',
		documents: 'Documents',
		banners: 'Banners',
		creatives: 'Creatives'
	},
	uk: {
		product: 'Product',
		documents: 'Documents',
		banners: 'Banners',
		creatives: 'Creatives'
	},
	de: {
		product: 'Produkt',
		documents: 'Dokumente',
		banners: 'Banner',
		creatives: 'Kreative'
	},
	vi: {
		product: 'Sản phẩm',
		documents: 'Tài liệu',
		banners: 'Biểu ngữ',
		creatives: 'Sáng tạo'
	},
	th: {
		product: 'สินค้า',
		documents: 'เอกสาร',
		banners: 'แบนเนอร์',
		creatives: 'ครีเอทีฟ'
	}
};

module.exports = {
	enum: statuses,
	locale: locale
};



// WEBPACK FOOTER //
// ./enums/offer-promo-categories.js